export default __webpack_public_path__ + "static/media/Novaa_Futurist_Still_1.9bd97e70.jpg";